<div [attr.data-qa]="qaTag"
     [class.modal-dialog-fixed-width]="shouldUseFixedDialogWidth"
     class="modal-dialog">
    @if (modalData.titleTranslationKey) {
        <h2 [attr.data-qa]="qaTag + '-title'"
            class="modal-dialog-title">{{ modalData.titleTranslationKey | translate: modalData.translateKeyParameters }}</h2>
    }
    <span [attr.data-qa]="qaTag + '-message'"
          [class]="messageCssClass"
          [innerHTML]="modalData.messageTranslationKey | translate: modalData.translateKeyParameters"></span>
    <div class="modal-dialog-action-text-buttons">
        <app-button (clicked)="confirm()"
                    [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                    [buttonColor]="ButtonColorEnum.RED"
                    [buttonText]="modalData.actionTranslationKey | translate : modalData.translateKeyParameters"
                    [linkUrl]="modalData.linkTargetOnConfirm"
                    [qaTag]="qaTag + '-confirm-button'"/>
        @if (modalData.cancelTranslationKey) {
            <app-button (clicked)="cancel()"
                        [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                        [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                        [buttonText]="modalData.cancelTranslationKey | translate : modalData.translateKeyParameters"
                        [qaTag]="qaTag + '-cancel-button'"/>
        }
    </div>
</div>
